// src/assessment2/AssessmentResultModal.js
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Typography,
    Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import DescriptionIcon from "@mui/icons-material/Description";
import { useTranslation } from 'react-i18next';
import AssessmentResultView from './AssessmentResultView';

export default function AssessmentResultModal({ open, onClose, data }) {
    const { t } = useTranslation();

    const showEmpty = !data;
    const hasPdfUrl = data?.reportUrl;
    const hasWordUrl = data?.wordReportUrl;

    const handleDownloadPDF = async () => {
        if (!hasPdfUrl) return;

        try {
            const response = await fetch(data.reportUrl);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `assessment-${data.applicantName || 'reporte'}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Error al descargar PDF:', error);
            // Fallback: abrir en nueva pestaña
            window.open(data.reportUrl, '_blank');
        }
    };

    const handleDownloadWord = async () => {
        if (!hasWordUrl) return;

        try {
            const response = await fetch(data.wordReportUrl);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `assessment-${data.applicantName || 'reporte'}.docx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Error al descargar Word:', error);
            // Fallback: abrir en nueva pestaña
            window.open(data.wordReportUrl, '_blank');
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                sx: { minHeight: '80vh', maxHeight: '90vh' }
            }}
        >
            <DialogTitle>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Typography variant="h6">
                        {t('evaluationResponses.assessmentResults')}
                        {data?.applicantName && ` - ${data.applicantName}`}
                    </Typography>
                    <IconButton onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent dividers sx={{ p: 0, overflow: 'auto' }}>
                {showEmpty ? (
                    <Typography variant="body2" color="text.secondary" sx={{ p: 3 }}>
                        {t('evaluationResponses.noResultsAvailable')}
                    </Typography>
                ) : (
                    <AssessmentResultView data={data} />
                )}
            </DialogContent>

            <DialogActions>
                <Button
                    startIcon={<DownloadIcon />}
                    variant="outlined"
                    onClick={handleDownloadPDF}
                    disabled={!hasPdfUrl}
                >
                    {t('evaluationResponses.downloadPdf')}
                </Button>

                <Button
                    startIcon={<DescriptionIcon />}
                    variant="outlined"
                    onClick={handleDownloadWord}
                    disabled={!hasWordUrl}
                >
                    {t('evaluationResponses.downloadWord')}
                </Button>

                <Button onClick={onClose}>
                    {t('close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}